import { ReactComponent as ViewBlock } from "../../../../img/butter_svgs/ViewBlock.svg";
import { BLOCK_EXPLORER_URL_BY_NETWORK } from "../../../../config/consts";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Spinner } from "../../../Spinner/Spinner";
import { Text } from "../../../general/Text";
import React from "react";
import { withIsVisible } from "../../../../utils/reactUtils";
import styled from "@emotion/styled";

export const ProcessingTransaction: React.FC<{ tx: string; isVisible: boolean }> = withIsVisible(
  ({ tx }) => {
    const network = GlobalStore.useState(s => s.network);
    const theme = GlobalStore.useState(s => s.theme);

    return (
      <Container>
        <DetailsContainer>
          <ViewBlock style={{ color: `${theme.font.primary.default} !important` }} />
          <ViewTransaction
            href={`${BLOCK_EXPLORER_URL_BY_NETWORK[network.id]}tx/${tx}`}
            target="_blank"
            rel="noreferrer"
          >
            <Text textStyle={"Paragraph"} size={"Large"} color={theme.font.primary.default}>
              Details
            </Text>
          </ViewTransaction>
        </DetailsContainer>
        <Spinner spinnerSize={18} />
      </Container>
    );
  }
);

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: end;
`;
const DetailsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
`;

const ViewTransaction = styled.a`
  display: flex;
  align-items: center;
  gap: 3px;
`;
